import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { MaterialModule } from '../../core/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { FooterComponent } from './footer/footer.component';
import { FormViewComponent } from './form-view/form-view.component';
import { FullPageLayoutComponent } from './full-page-layout/full-page-layout.component';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { NotLoggedFooterComponent } from './not-logged-footer/not-logged-footer.component';
import { NotLoggedTopbarComponent } from './not-logged-topbar/not-logged-topbar.component';
import { NotificationsOverlayComponent } from './notifications-overlay/notifications-overlay.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SpeedDialFabComponent } from './speed-dial-fab/speed-dial-fab.component';
import { TopbarLayoutComponent } from './topbar-layout/topbar-layout.component';
import { TopbarComponent } from './topbar/topbar.component';

@NgModule({
    imports: [CommonModule, BrowserModule, RouterModule, TranslatePipe, TranslateDirective, MaterialModule, PortalModule, PipesModule],
    declarations: [
        LanguageSwitcherComponent,
        TopbarComponent,
        DefaultLayoutComponent,
        TopbarLayoutComponent,
        FullPageLayoutComponent,
        FooterComponent,
        SidebarComponent,
        NotLoggedTopbarComponent,
        NotLoggedFooterComponent,
        SpeedDialFabComponent,
        FormViewComponent,
        NotificationsOverlayComponent
    ],
    exports: [DefaultLayoutComponent, TopbarLayoutComponent, FullPageLayoutComponent, FormViewComponent]
})
export class LayoutsModule {}
